var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-tool-bar',{on:{"toggleDrawer":function($event){_vm.drawer = !_vm.drawer}}}),_c('v-content',{staticClass:"page-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }